export default {
  // Super-Administrateur (ID 60):
  "beepiz-superadministrator": {
    "realtime-detail": true,
    "realtime-geo": true,
    "alerts-detail": true,
    "alerts-geo": true,
    "kpi-config": true,
    "reports-detail": true,
    "reports-download": true,
    "licences-config": true,
    "users-watchmen": true,
    "users-profil": true,
    "users-device": true,
    "users-epi": true,
    "users-planning": true,
    "users-remote": true,
    "users-card": true,
    "groups-detail": true,
    "groups-config": true,
    "indoor-plans": true,
    "indoor-ap": true,
    "patrols-detail": true,
    "patrols-config": true,
    "certificate-config": true,
    "phonebook-config": true,
  },
  // Administrateur (ID 61):
  "beepiz-administrator": {
    "realtime-detail": true,
    "realtime-geo": true,
    "alerts-detail": true,
    "alerts-geo": true,
    "kpi-config": true,
    "reports-detail": true,
    "reports-download": true,
    "licences-config": true,
    "users-watchmen": true,
    "users-profil": true,
    "users-device": true,
    "users-epi": true,
    "users-planning": true,
    "users-remote": true,
    "users-card": true,
    "groups-detail": true,
    "groups-config": false,
    "indoor-plans": true,
    "indoor-ap": true,
    "patrols-detail": true,
    "patrols-config": true,
    "certificate-config": true,
    "phonebook-config": true,
  },
  // Gestionnaire (ID 63):
  "beepiz-manager": {
    "realtime-detail": true,
    "realtime-geo": true,
    "alerts-detail": true,
    "alerts-geo": true,
    "kpi-config": true,
    "reports-detail": true,
    "reports-download": true,
    "licences-config": true,
    "users-watchmen": true,
    "users-profil": true,
    "users-device": true,
    "users-epi": true,
    "users-planning": true,
    "users-remote": true,
    "users-card": true,
    "groups-detail": true,
    "groups-config": false,
    "indoor-plans": false,
    "indoor-ap": false,
    "patrols-detail": true,
    "patrols-config": false,
    "certificate-config": true,
    "phonebook-config": true,
  },
  // Superviseur (ID 64):
  "beepiz-supervisor": {
    "realtime-detail": true,
    "realtime-geo": true,
    "alerts-detail": true,
    "alerts-geo": true,
    "kpi-config": false,
    "reports-detail": true,
    "reports-download": false,
    "licences-config": false,
    "users-watchmen": false,
    "users-profil": false,
    "users-device": false,
    "users-epi": false,
    "users-planning": false,
    "users-remote": false,
    "users-card": false,
    "groups-detail": false,
    "groups-config": false,
    "indoor-plans": false,
    "indoor-ap": false,
    "patrols-detail": true,
    "patrols-config": false,
    "certificate-config": false,
    "phonebook-config": false,
  },
  // Superviseur restreint (ID 107):
  "beepiz-supervisor-no-geoloc": {
    "realtime-detail": true,
    "realtime-geo": false,
    "alerts-detail": true,
    "alerts-geo": true,
    "kpi-config": false,
    "reports-detail": true,
    "reports-download": false,
    "licences-config": false,
    "users-watchmen": false,
    "users-profil": false,
    "users-device": false,
    "users-epi": false,
    "users-planning": false,
    "users-remote": false,
    "users-card": false,
    "groups-detail": false,
    "groups-config": false,
    "indoor-plans": false,
    "indoor-ap": false,
    "patrols-detail": false,
    "patrols-config": false,
    "certificate-config": false,
    "phonebook-config": false,
  },
  // Gestionnaire de licences et profils (ID 103):
  "beepiz-manager-licence": {
    "realtime-detail": false,
    "realtime-geo": false,
    "alerts-detail": false,
    "alerts-geo": false,
    "kpi-config": false,
    "reports-detail": false,
    "reports-download": false,
    "licences-config": true,
    "users-watchmen": true,
    "users-profil": true,
    "users-device": true,
    "users-epi": true,
    "users-planning": false,
    "users-remote": true,
    "users-card": true,
    "groups-detail": true,
    "groups-config": false,
    "indoor-plans": false,
    "indoor-ap": false,
    "patrols-detail": false,
    "patrols-config": false,
    "certificate-config": false,
    "phonebook-config": true,
  },
  // Maintenance (ID 62):
  "beepiz-maintenance": {
    "realtime-detail": false,
    "realtime-geo": false,
    "alerts-detail": false,
    "alerts-geo": false,
    "kpi-config": false,
    "reports-detail": false,
    "reports-download": false,
    "licences-config": false,
    "users-watchmen": false,
    "users-profil": false,
    "users-device": false,
    "users-epi": false,
    "users-planning": false,
    "users-remote": false,
    "users-card": false,
    "groups-detail": false,
    "groups-config": false,
    "indoor-plans": true,
    "indoor-ap": true,
    "patrols-detail": false,
    "patrols-config": false,
    "certificate-config": false,
    "phonebook-config": false,
  },
};



// WEBPACK FOOTER //
// ./src/components/roles/beepiz-permissions.js